module.exports = __webpack_public_path__ + "static/media/client_5.df78beb1.png";